// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2mN2U","dragIcon":"Choice_dragIcon__3TxZ8","left":"Choice_left__2OlBq","input":"Choice_input__pQBJE"};